import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a shop awning: a sloped fabric canopy in muted dark red on
// two slim matte-black posts at the back edge, so the piece stands on its
// own in front of a storefront tile. The canopy sits between 2.2 and 2.5 m
// and slopes down toward +Z (the street side).
const FABRIC = "#8a3a34";
const FABRIC_DARK = "#753029";
const BLACK = "#2e2e30";

export const awning = defineModel({
  id: "awning",
  batchId: "modern",
  name: "Awning",
  tags: ["modern", "outdoor", "structure", "awning", "shop", "storefront", "canopy"],
  summary: "A dark-red shop awning on two slim matte-black back posts.",
  description:
    "A one-tile cafe / storefront awning of the Modern Living kit: a sloped " +
    "dark-red fabric canopy from 2.5 m at the back down to about 2.2 m at " +
    "the front (+Z), with a hanging valance strip, carried by two slim " +
    "matte-black posts at the back edge so it stands free in front of a " +
    "storefront tile.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // slim matte-black posts at the back edge
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 2.5, 8), color: BLACK, position: [-0.44, 1.25, -0.44] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 2.5, 8), color: BLACK, position: [0.44, 1.25, -0.44] },
      // back rail joining the posts
      { geometry: new THREE.BoxGeometry(0.94, 0.06, 0.06), color: BLACK, position: [0, 2.47, -0.44] },
      // sloped fabric canopy (back at ~2.5 down to ~2.2 at the front)
      {
        geometry: new THREE.BoxGeometry(1.0, 0.04, 0.95),
        color: FABRIC,
        position: [0, 2.35, 0.02],
        rotation: [0.31, 0, 0],
      },
      // hanging valance strip along the front edge
      {
        geometry: new THREE.BoxGeometry(1.0, 0.14, 0.03),
        color: FABRIC_DARK,
        position: [0, 2.15, 0.47],
      },
    ];
  },
  animations: [],
});
